import React from 'react';
import ReactDOMClient from 'react-dom/client';

import TuecedeTransferPortalApp from './TuecedeTransferPortalAppPanel';

const app = document.getElementById('root');
const root = ReactDOMClient.createRoot(app);

root.render(<TuecedeTransferPortalApp />);
